export default ($el) => {
  const scrollOverflowElToTop = () => {
    const $elementsToScroll = $el.find('[data-expand--scroll-to-top]');

    $elementsToScroll.each((_i, el) => {
      el.scrollTop = 0;
    });
  };

  const toggleClasses = () => {
    const $elementsToToggle = $el.find('[data-expand--toggle-classes]');

    $elementsToToggle.each((_i, el) => {
      const classesToToggle = el.dataset['expand-ToggleClasses'].split(' ');

      $(el).toggleClass(classesToToggle);
    });
  };

  const toggleTriggerText = () => {
    const $triggerEl = $el.find('[data-expand--trigger] h2');
    const newElText = $triggerEl.text() === 'Expand' ? 'Collapse' : 'Expand';
    $triggerEl.text(newElText);
  };

  $el.on('click', '[data-expand--trigger]', () => {
    toggleClasses();
    toggleTriggerText();
    scrollOverflowElToTop();
  });
};
